var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "tr",
    _vm._b(
      { staticClass: "default-table-row", style: _vm.custom_style },
      "tr",
      _vm.$attrs,
      false
    ),
    [_vm._t("default")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }